/**
 * Class Name Utility
 *
 * Combines clsx and tailwind-merge for conditional class names
 * with proper Tailwind CSS class merging.
 *
 * Usage:
 *   cn('px-4 py-2', isActive && 'bg-primary', className)
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
